import { render, staticRenderFns } from "./record2.vue?vue&type=template&id=148a5e06&scoped=true&"
import script from "./record2.vue?vue&type=script&lang=js&"
export * from "./record2.vue?vue&type=script&lang=js&"
import style0 from "./record2.vue?vue&type=style&index=0&id=148a5e06&prod&lang=scss&scoped=true&"
import style1 from "./record2.vue?vue&type=style&index=1&id=148a5e06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148a5e06",
  null
  
)

export default component.exports